var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-scrollbar',{staticClass:"scrollbar-handle",staticStyle:{"height":"100%"}},[(_vm.$route.meta.keepAlive)?_c('div',[_c('keep-alive',[_c('router-view')],1)],1):_c('div',[(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }